import React, { useEffect, useRef, useState } from 'react';
import { Button, Modal, Badge } from 'react-bootstrap';
import { Link } from "react-router-dom";
import Select from "react-select";
import LightGallery from 'lightgallery/react';
// import styles
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import vehicle from '../../../../images/vehicle/default_vehicle.png';
import documents from '../../../../images/doc.png';
import staff_img from '../../../../images/staff/staff_1.png';

const ViewComplaint = ({ show, onClose, data }) => {

    const imgBaseUrl = process.env.REACT_APP_IMG_BASE_URL;
    
    const [selectedOption, setSelectedOption] = useState(null);
    const chatScrollRef = useRef(null);

    const [complaintsdata, setComplaint] = useState({});
    const [convo, setconvo] = useState({ conversation: [] });
    const [attachments, setAtatchments] = useState({});

    useEffect (() => {
        if (data) {
            setComplaint(data.complaint);
            setAtatchments(data.attachments);
            const parsedComplaint = {
                conversation: JSON.parse(data.complaint.conversation || '[]')
            };
            setconvo(parsedComplaint);
        }
    }, [data])


    useEffect(() => {
        if (chatScrollRef.current) {
            chatScrollRef.current.scrollTop = chatScrollRef.current.scrollHeight;
        }
    }, []);


    const onInit = () => {
        //   console.log('lightGallery has been initialized');
    };

    const isImageFile = (filename) => {
        const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'];
        const ext = filename.split('.').pop().toLowerCase();
        return imageExtensions.includes(ext);
    };

    const handleDownload = (fileUrl, fileName) => {
        const link = document.createElement('a');
        link.href = fileUrl;
        // link.setAttribute('download', fileName);
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    
    return (
        <Modal show={show} onHide={onClose} size="lg">
            <div className="modal-content border border-red rounded-xxl">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">
                        <label>View Complaint</label>
                        <label className='me-1 ms-1'>-</label>
                        {complaintsdata.complaint_status === 0 && (
                            <label className='py-1 px-2 fs-4 border border-white shadow-lg text-white badge bg-none'>Open</label>
                        )}
                        {complaintsdata.complaint_status === 1 && (
                            <label className='py-1 px-2 fs-4 border border-white shadow-lg text-white badge bg-none'>In Progress</label>
                        )}
                        {complaintsdata.complaint_status === 2 && (
                            <label className='py-1 px-2 fs-4 border border-white shadow-lg text-white badge bg-none'>Resolved</label>
                        )}
                        {complaintsdata.complaint_status === 3 && (
                            <label className='py-1 px-2 fs-4 border border-white shadow-lg text-white badge bg-none'>Closed</label>
                        )}
                    </h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className='text-white'>×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <div className='row'>
                        <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                            <label className='text-gray-800 font-w500 fs-7'>Date & Time</label>
                            <label className='text-danger fs-6 font-w500'>
                                <span>{data.date}</span>
                                <span className='me-1 ms-1'></span>
                                <span>{data.time}</span></label>
                        </div>
                        <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                            <label className='text-gray-800 font-w500 fs-7'>Customer</label>
                            <label className='text-black fs-6 font-w500'>{data.subscriber_name}</label>
                        </div>
                        <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                            <label className='text-gray-800 font-w500 fs-7'>Phone No</label>
                            <label className='text-black fs-6 font-w500'>{data.subscriber_mobile}</label>
                        </div>
                        <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                            <label className='text-gray-800 font-w500 fs-7'>Package Period</label>
                            <label className='text-black fs-6 font-w500'>{data.timeline_name} ({data.timeline_duration} Days)</label>
                        </div>
                        <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                            <label className='text-gray-800 font-w500 fs-7'>Package</label>
                            <label className='text-black fs-6 font-w500'>{data.product_name}</label>
                        </div>
                        <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                            <label className='text-gray-800 font-w500 fs-7'>Complaint Type</label>
                            <label className='text-black fs-6 font-w500'>
                                <Badge bg="info" className='text-white fs-7 py-0 px-1'>
                                    <span>{data.c_type_name}</span>
                                </Badge></label>
                        </div>
                        <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                            <label className='text-gray-800 font-w500 fs-7'>Reason</label>
                            <label className='text-black fs-6 font-w500'>{complaintsdata.close_reason ? complaintsdata.close_reason : '-'}</label>
                        </div>
                        
                        <div className="col-lg-4 col-md-12 col-sm-12  mb-2">
                            <label className='text-gray-800 font-w500 fs-7'>Attachment</label>
                            {attachments.length > 0 ? (
                                <>
                                    <div className=''>
                                        <div className="d-flex overflow-auto" style={{whiteSpace: 'nowrap', gap: '1rem', paddingBottom: '8px'}}>


                                            {attachments.map((doc, index) => {
                                                const fileUrl = imgBaseUrl + '/' + doc.file_path;
                                                const isImage = isImageFile(doc.file_name);
                                                return (
                                                    <div key={index} className="preview-image-container position-relative">
                                                        <img
                                                            id={`attachment-${index}`}
                                                            src={isImage ? fileUrl : documents}
                                                            alt={doc.file_name}
                                                            className="w-100px h-110px object-fit-cover"
                                                        />
                                                        <a
                                                            // href={fileUrl}
                                                            // download={doc.file_name}
                                                            onClick={() => handleDownload(fileUrl, doc.file_name)}
                                                            className="download-icon position-absolute top-50 start-50 translate-middle p-2"
                                                            style={{
                                                                backgroundColor: 'rgb(180 228 126)',
                                                                borderRadius: '50%',
                                                            }}
                                                        >
                                                            <i className="fa-solid fa-download text-black fs-6"></i>
                                                        </a>
                                                    </div>
                                                );
                                            })}

                                        </div>
                                    </div>
                                </>
                            ) : (
                                <div>
                                   <label className='text-black fs-6 font-w500'>
                                        No Attachments
                                    </label>
                                </div>
                            )}

                        </div>

                    </div>
                    <div className='rounded border border-gray mt-3'>
                        <div className='text-center mb-0'>
                            <div className="bg-danger-light border-bottom text-black font-w600 fs-3">
                                <label className='mb-0'>Conversation</label>
                            </div>
                        </div>
                        {convo.conversation && convo.conversation.length > 0 ? (
                            <div className='scroll-y min-h-300px mh-300px px-3 py-2' ref={chatScrollRef} id="chat_scroll">
                                {convo.conversation.map((item, index) => {
                                    const isComplaint = !!item.complaint;
                                    const isEven = index % 2 === 0;

                                    // Common formatting
                                    const datetime = new Date(item.datetime || item.reason_datetime).toLocaleString("en-GB", {
                                        day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit',
                                        hour12: true
                                    });

                                    const date = new Date(item.datetime || item.reason_datetime).toLocaleString("en-GB", {
                                        day: '2-digit', month: 'short', year: 'numeric'
                                    });

                                    return (
                                        <>
                                            <div className="d-flex justify-content-center align-items-start mb-3">
                                                <div className="px-3 py-0 rounded fw-semibold text-start bg-gray-300">
                                                    <div className="d-flex align-items-center">
                                                        <label className="fs-8 font-w400 text-gray-800">{date}</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className={`d-flex ${isComplaint ? 'justify-content-start' : 'justify-content-end'} mb-3`} key={index}>
                                                <div className={`d-flex flex-column mw-50 ${isComplaint ? 'align-items-start' : 'align-items-end'}`}>
                                                    <div className={`px-2 py-1 rounded border ${isComplaint ? 'bg-danger-light text-danger border-danger text-start msg_recv' : 'bg-info-light text-info border-info msg_send'}`}>
                                                        {isComplaint && (
                                                        <>
                                                            <div className="d-block fs-8 font-w600 text-center"><u>{item.complaint_type || 'Complaint'}</u></div>
                                                            <div className="fs-8 font-w400 mb-1 text-black">{item.complaint}</div>
                                                            <div className="border-bottom border-danger"></div>
                                                            <div className="d-block fs-9 font-w400 text-end text-black">{datetime}</div>
                                                        </>
                                                        )}
                                                        {!isComplaint && (
                                                        <>
                                                            <div className='d-flex align-items-center mb-2'>
                                                            {item.image ? (
                                                                <img src={item.image} alt="Resolved Person" className='cursor-pointer rounded-pill w-35px h-35px' />
                                                            ):(
                                                                <img src={staff_img} alt="Resolved Person" className='cursor-pointer rounded-pill w-35px h-35px' />
                                                            )}
                                                            <div className='ms-1'>
                                                                <div className='text-info font-w400 fs-7'>{item.reason_provider_name}</div>
                                                                <div className="d-block fs-9 font-w400 text-end text-black">{datetime}</div>
                                                            </div>
                                                            </div>
                                                            <div className="border-bottom border-info mb-1"></div>
                                                            <div className="fs-8 font-w400 mb-1 text-black">{item.reason}</div>
                                                        </>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                            {!isComplaint && (
                                                <div className="border-bottom my-2"></div>
                                            )}
                                        </>
                                    );
                                })}
                            </div>
                        ) : (
                            <div className="text-center text-muted py-5">
                                <span className="fs-7">No conversation available</span>
                            </div>
                        )}
                    </div>
                </div>
            </div >
        </Modal >
    );
};

export default ViewComplaint;
